module.exports = __webpack_public_path__ + "img/edit.b609a297.svg";